export const shortDrivingCategories = (drivingCategories) => {
  const modified = [];
  drivingCategories &&
    drivingCategories.map((item) => {
      modified.push({ ...item, label: item.label.substring(0, 1) });
    });
  return modified;
};